import { buildCommunityCustomEmojiPublicUrl, parseCommunityCustomEmojiToken } from './communityEmojiTokens'

const CUSTOM_EMOJI_PREFIX = ':cae:'
const TOKEN_REGEX = /:cae:[^\s:]+:/g

function shouldProcess(html: string): boolean {
  return html.includes(CUSTOM_EMOJI_PREFIX)
}

export function renderCommunityCustomEmojiTokensInHtml(html: string): string {
  const input = String(html || '').trim()
  if (!input) return ''
  if (!shouldProcess(input)) return input
  if (typeof DOMParser === 'undefined') return input

  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(input, 'text/html')

    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT)
    const textNodes: Text[] = []
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      textNodes.push(node as Text)
    }

    textNodes.forEach((textNode) => {
      if (!textNode.parentNode) return
      const value = textNode.nodeValue || ''
      if (!value.includes(CUSTOM_EMOJI_PREFIX)) return

      TOKEN_REGEX.lastIndex = 0
      const matches = Array.from(value.matchAll(TOKEN_REGEX))
      if (!matches.length) return

      const frag = doc.createDocumentFragment()
      let lastIndex = 0

      matches.forEach((match) => {
        const token = match[0]
        const index = match.index ?? 0

        if (index > lastIndex) {
          frag.appendChild(doc.createTextNode(value.slice(lastIndex, index)))
        }

        const parsed = parseCommunityCustomEmojiToken(token)
        const url = parsed ? buildCommunityCustomEmojiPublicUrl(parsed.id) : null
        if (!parsed || !url) {
          frag.appendChild(doc.createTextNode(token))
          lastIndex = index + token.length
          return
        }

        const img = doc.createElement('img')
        img.setAttribute('src', url)
        img.setAttribute('alt', token)
        img.setAttribute('loading', 'lazy')
        img.setAttribute('data-community-custom-emoji', parsed.id)
        img.setAttribute(
          'class',
          'inline-block h-[1.1em] w-[1.1em] align-[-0.2em] object-contain',
        )
        frag.appendChild(img)
        lastIndex = index + token.length
      })

      if (lastIndex < value.length) {
        frag.appendChild(doc.createTextNode(value.slice(lastIndex)))
      }

      try {
        textNode.parentNode.replaceChild(frag, textNode)
      } catch {
        // ignore
      }
    })

    return String(doc.body.innerHTML || '').trim()
  } catch {
    return input
  }
}

